<template>
  <div class="file">
      <img v-if="getFileExtension() == 'ai'" src="/img/icons/ai.svg" alt="" />
      <img v-if="getFileExtension() == 'cdr'" src="/img/icons/cdr.svg" alt="" />
      <img v-if="getFileExtension() == 'eps'" src="/img/icons/eps.svg" alt="" />
      <img v-if="getFileExtension() == 'indd'" src="/img/icons/indd.svg" alt="" />
      <img v-if="getFileExtension() == 'jpg' || getFileExtension() == 'jpeg'" src="/img/icons/jpg.svg" alt="" />
      <img v-if="getFileExtension() == 'pdf'" src="/img/icons/pdf.svg" alt="" />
      <img v-if="getFileExtension() == 'png'" src="/img/icons/png.svg" alt="" />
      <img v-if="getFileExtension() == 'psd'" src="/img/icons/psd.svg" alt="" />
      <img v-if="getFileExtension() == 'rar'" src="/img/icons/rar.svg" alt="" />
      <img v-if="getFileExtension() == 'zip'" src="/img/icons/zip.svg" alt="" />
      <span>{{filename ? filename : file.name}}</span>
  </div>
</template>

<script>

export default {
  name: 'adx-file',
  components: {
      
  },
  props: {
    file: {
      required: false
    },
    filename: {
      required: false
    }
  },
  data() {
    return {
        
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
      
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    getFileExtension() {
      var name = this.filename ? this.filename : this.file.name
      return name.substring(name.lastIndexOf('.')+1, name.length) || name
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>